import { render, staticRenderFns } from "./SlackInquiryForm.vue?vue&type=template&id=aa243a62&scoped=true&"
import script from "./SlackInquiryForm.vue?vue&type=script&lang=js&"
export * from "./SlackInquiryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa243a62",
  null
  
)

export default component.exports